<template lang="html">
  <div class="mt6 tc">
    <div class="">
      <img src="/static/logos/parlay_logo.svg" alt="" style="width: 150px" />
    </div>

    <div class="pl-title mv4">
      Oops! It looks like we couldn't locate your account.

      <br /><br />
      Clever login is only available if your school or district
      <br />
      is a Parlay member and created an account on your behalf.
      <br /><br />
      Click below to login or signup with your email.
    </div>

    <pl-button @click.native="$router.push('login')" class="pl-primary">
      Back
    </pl-button>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// clever_error.vue?1c4403bc